import { STORE_TRANSFER_URL } from "../../CONSTANTS";
import { callGetAxios, callPostAxios, callPutAxios } from "../common/common";

// Store to Store transfer inside one warehouse.

export const getStoreTransferList = (data) => {
    return callPostAxios(STORE_TRANSFER_URL() + "getAllRecords", data, "getting Store Transfer List");
};

// { uuid: warehouseUuid, uuid2: itemUuid } -> batch rows with location + available qty
export const getStoreTransferAvailableBatches = (warehouseUuid, itemUuid) => {
    return callPostAxios(STORE_TRANSFER_URL() + "getAvailableBatches", { uuid: warehouseUuid, uuid2: itemUuid }, "getting available batches");
};

export const addStoreTransfer = (data) => {
    return callPostAxios(STORE_TRANSFER_URL(), data, "adding Store Transfer");
};

export const getStoreTransferDetails = (uuid) => {
    return callGetAxios(STORE_TRANSFER_URL() + uuid, "getting Store Transfer Details");
};

export const storeTransferApprove = (uuid) => {
    return callPutAxios(STORE_TRANSFER_URL() + "approved/" + uuid, {}, "approving Store Transfer");
};

export const storeTransferCancel = (uuid) => {
    return callPutAxios(STORE_TRANSFER_URL() + "cancel/" + uuid, {}, "cancelling Store Transfer");
};

export const getStoreTransferHistory = (code) => {
    return callGetAxios(STORE_TRANSFER_URL() + "history/" + code, "getting Store Transfer History");
};
